import { isCSSStyleSheet, typeCheck } from "@knyt/artisan";
import { cssStyleSheetToString } from "./cssStyleSheetToString.js";
import { isCSSSerializable } from "./isCSSSerializable.js";
import { StyleSheet } from "./StyleSheet.js";
/**
 * @internal scope: package
 */
export function cssTemplateTag(cssText, ...values) {
    let result = "";
    for (let i = 0; i < cssText.length; i++) {
        result += cssText[i];
        if (i < values.length) {
            const value = values[i];
            if (typeof value === "string" || typeof value === "number") {
                result += String(value);
                continue;
            }
            if (isCSSStyleSheet(value)) {
                result += cssStyleSheetToString(value);
                continue;
            }
            if (isCSSSerializable(value)) {
                result += value.toCSSString();
                continue;
            }
            // TODO: Remove in production build
            {
                typeCheck(typeCheck.identify(value));
            }
            // This should be unreachable, but we'll log an error just in case,
            // and then proceed without adding the value to the result.
            // TODO: Remove in production build
            console.error(new TypeError(`Unsupported value type: ${typeof value}. Expected string, number, CSSStyleSheet, or CSSSerializable.`));
        }
    }
    return StyleSheet.fromCSS(result);
}
